<template>
  <v-container fluid class="pa-4">
    <carga v-if="cargar" />
    <Alerta v-if="respuestaAlerta" :parametros="parametros" />

    <v-card class="shadowCard mb-4" elevation="0">
      <v-card-title class="py-3 d-flex align-center flex-wrap">
        <v-icon left color="primary">mdi-view-grid</v-icon>
        Panel Grupo de Apoyo
        <v-spacer />
        <v-btn
          small
          tile
          outlined
          color="secondary"
          class="mr-2"
          :href="$router.resolve({ name: 'MapaSucursales' }).href"
          target="_blank"
          rel="noopener noreferrer"
        >
          <v-icon left small>mdi-map-marker-radius</v-icon>
          Ir al mapa
        </v-btn>
        <v-btn
          small
          tile
          outlined
          color="primary"
          class="mr-2"
          :disabled="!puedeConsultar"
          :loading="consultando"
          @click="consultarMatriz"
        >
          Consultar
        </v-btn>
        <v-btn
          small
          tile
          color="primary"
          class="mr-2"
          :disabled="!puedeConsultar"
          :loading="generando"
          @click="generarMatriz"
        >
          Generar / actualizar
        </v-btn>
        <v-btn
          small
          tile
          color="success"
          :disabled="!filasVisibles.length"
          @click="exportarExcelMatriz"
        >
          <v-icon left small>mdi-microsoft-excel</v-icon>
          Excel
        </v-btn>
      </v-card-title>

      <v-card-text>
        <v-alert
          v-if="alertaCuota"
          type="warning"
          dense
          outlined
          class="mb-3"
        >
          Uso de Google Maps Directions cerca del límite gratuito
          ({{ googleUso.usados }} / {{ googleUso.limite_gratis }} · {{ googleUso.porcentaje }}% en {{ googleUso.anio_mes }}).
          La generación prioriza rutas gratuitas (OSRM) y solo usa Google si hace falta.
        </v-alert>

        <v-row dense>
          <v-col cols="12" sm="6" md="3">
            <v-select
              v-model="idCiclo"
              :items="ciclos"
              item-text="ciclo"
              item-value="id_ciclo"
              label="Ciclo"
              filled
              dense
              hide-details
              :menu-props="{ offsetY: true }"
            />
          </v-col>
          <v-col cols="12" sm="6" md="2">
            <v-select
              v-model="semana"
              :items="opcionesSemana"
              label="Semana"
              filled
              dense
              hide-details
              :menu-props="{ offsetY: true }"
            />
          </v-col>
          <v-col cols="12" sm="6" md="2">
            <v-select
              v-model="ciudad"
              :items="opcionesCiudad"
              label="Ciudad"
              filled
              dense
              hide-details
              clearable
              :menu-props="{ offsetY: true }"
            />
          </v-col>
          <v-col cols="12" sm="6" md="5">
            <v-autocomplete
              v-model="filtroTeacherId"
              :items="opcionesTeachers"
              item-text="nombre"
              item-value="id_teacher"
              label="Filtrar teacher"
              filled
              dense
              hide-details
              clearable
              :disabled="!matriz"
              :menu-props="{ offsetY: true }"
            />
          </v-col>
        </v-row>

        <div v-if="snapInfo" class="caption grey--text mt-3">
          Snapshot: {{ snapInfo.generado_en }}
          · {{ snapInfo.total_planteles }} planteles
          · {{ snapInfo.total_teachers }} teachers
          <span v-if="filtroTeacherId"> · filtro teacher activo</span>
          <span v-if="snapInfo.llamadas_google"> · Google: {{ snapInfo.llamadas_google }}</span>
        </div>
      </v-card-text>
    </v-card>

    <v-card class="shadowCard" elevation="0">
      <v-card-text class="pa-0">
        <div v-if="!matriz && !consultando" class="pa-6 text-center grey--text">
          Selecciona ciclo y semana, luego Consultar o Generar / actualizar.
        </div>
        <div v-else-if="matriz && !filasVisibles.length" class="pa-6 text-center grey--text">
          No hay filas con el filtro actual.
        </div>
        <div v-else-if="matriz" class="apoyo-matriz-wrap">
          <table class="apoyo-matriz">
            <colgroup>
              <col class="apoyo-matriz__col-plantel" />
              <col
                v-for="op in matriz.columnas"
                :key="'col-' + op"
                class="apoyo-matriz__col-opcion"
              />
            </colgroup>
            <thead>
              <tr>
                <th class="apoyo-matriz__plantel">Plantel</th>
                <th
                  v-for="op in matriz.columnas"
                  :key="'h-' + op"
                  class="apoyo-matriz__opcion"
                >
                  OPCION {{ op }}
                </th>
              </tr>
            </thead>
            <tbody>
              <template v-for="fila in filasVisibles">
                <tr :key="'n-' + fila.id_plantel">
                  <td class="apoyo-matriz__plantel-nombre" rowspan="2">{{ fila.nombre }}</td>
                  <td
                    v-for="(celda, idx) in fila.celdas"
                    :key="'c-' + fila.id_plantel + '-' + idx"
                    class="apoyo-matriz__celda"
                    :class="{ 'apoyo-matriz__celda--dim': esCeldaAtenua(celda) }"
                  >
                    <div
                      v-if="celda"
                      class="apoyo-matriz__chip"
                      :style="estiloCelda(celda)"
                      :title="tituloCelda(celda)"
                    >
                      <div class="apoyo-matriz__nombre">{{ nombreVisible(celda.nombre) }}</div>
                    </div>
                  </td>
                </tr>
                <tr :key="'t-' + fila.id_plantel" class="apoyo-matriz__tiempo-row">
                  <td
                    v-for="(celda, idx) in fila.celdas"
                    :key="'tm-' + fila.id_plantel + '-' + idx"
                    class="apoyo-matriz__tiempo-celda"
                    :class="{ 'apoyo-matriz__celda--dim': esCeldaAtenua(celda) }"
                    :style="estiloTiempo(celda)"
                  >
                    <span v-if="celda && celda.tiempo_minutos != null">
                      {{ celda.tiempo_minutos }} min
                    </span>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import { saveAs } from 'file-saver'
import Alerta from '@/components/alertas/Alerta.vue'
import carga from '@/components/alertas/carga.vue'
import validarErrores from '@/mixins/validarErrores'
import funcionesExcel from '@/mixins/funcionesExcel'

function hslAHex (h, s, l) {
  const sat = s / 100
  const light = l / 100
  const c = (1 - Math.abs(2 * light - 1)) * sat
  const x = c * (1 - Math.abs(((h / 60) % 2) - 1))
  const m = light - c / 2
  let r = 0
  let g = 0
  let b = 0
  if (h < 60) { r = c; g = x; b = 0 }
  else if (h < 120) { r = x; g = c; b = 0 }
  else if (h < 180) { r = 0; g = c; b = x }
  else if (h < 240) { r = 0; g = x; b = c }
  else if (h < 300) { r = x; g = 0; b = c }
  else { r = c; g = 0; b = x }
  const toHex = (n) => {
    const v = Math.round((n + m) * 255)
    const hx = v.toString(16)
    return hx.length === 1 ? '0' + hx : hx
  }
  return ('#' + toHex(r) + toHex(g) + toHex(b)).toUpperCase()
}

/** Colores distintos por índice (ángulo áureo); evita repeticiones cercanas. */
function colorPorIndice (indice) {
  const hue = (Number(indice) * 137.508) % 360
  const sat = 58 + (Number(indice) % 4) * 8
  const light = 70 + (Number(indice) % 3) * 5
  return hslAHex(hue, sat, Math.min(light, 82))
}

function escapeHtml (texto) {
  return String(texto == null ? '' : texto)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
}

export default {
  name: 'PanelGrupoApoyo',
  components: { Alerta, carga },
  mixins: [validarErrores, funcionesExcel],
  data () {
    return {
      cargar: false,
      consultando: false,
      generando: false,
      respuestaAlerta: false,
      parametros: {
        textColor: '#FFFFFF',
        color: 'error',
        mensajeAlerta: '',
        textoBtn: '',
        icon: '',
        dialog: false,
      },
      ciclos: [],
      idCiclo: null,
      semana: 1,
      ciudad: 'MTY',
      filtroTeacherId: null,
      opcionesSemana: [1, 2, 3, 4, 5],
      opcionesCiudad: ['MTY', 'CDMX', 'GDL'],
      matriz: null,
      snapInfo: null,
      googleUso: {
        anio_mes: '',
        usados: 0,
        limite_gratis: 10000,
        porcentaje: 0,
      },
      alertaCuota: false,
      colorPorTeacher: {},
    }
  },
  computed: {
    ...mapGetters('login', ['getdatosUsuarioERPERP']),
    puedeConsultar () {
      return this.idCiclo != null && this.semana != null
    },
    opcionesTeachers () {
      const mapa = {}
      const filas = (this.matriz && this.matriz.filas) || []
      for (let i = 0; i < filas.length; i++) {
        const celdas = filas[i].celdas || []
        for (let j = 0; j < celdas.length; j++) {
          const celda = celdas[j]
          if (!celda || celda.id_teacher == null) continue
          const id = Number(celda.id_teacher)
          if (!mapa[id]) {
            mapa[id] = {
              id_teacher: id,
              nombre: this.nombreVisible(celda.nombre),
            }
          }
        }
      }
      return Object.keys(mapa)
        .map((k) => mapa[k])
        .sort((a, b) => String(a.nombre).localeCompare(String(b.nombre), 'es'))
    },
    filasVisibles () {
      const filas = (this.matriz && this.matriz.filas) || []
      if (this.filtroTeacherId == null || this.filtroTeacherId === '') return filas
      const idFiltro = Number(this.filtroTeacherId)
      return filas.filter((fila) => {
        const celdas = fila.celdas || []
        for (let i = 0; i < celdas.length; i++) {
          if (celdas[i] && Number(celdas[i].id_teacher) === idFiltro) return true
        }
        return false
      })
    },
  },
  created () {
    this.cargarCiclos()
    this.cargarMeta()
  },
  methods: {
    mensajeErrorHttp (error, fallback) {
      if (error && error.response && error.response.data && error.response.data.message) {
        return error.response.data.message
      }
      return fallback || 'Error inesperado'
    },
    nombreVisible (nombre) {
      return String(nombre || '')
        .replace(/^Teacher\s+/i, '')
        .trim()
    },
    cargarCiclos () {
      this.cargar = true
      this.$http.get('roles.ciclos.all').then((response) => {
        const raw = response.body || response.data || []
        const filtrados = []
        for (let i = 0; i < raw.length; i++) {
          const nombre = String((raw[i] && raw[i].ciclo) || '')
          if (nombre.indexOf('FE') === -1 && nombre.indexOf('CICLO') !== -1) {
            filtrados.push(raw[i])
          }
        }
        this.ciclos = filtrados
        if (!this.idCiclo && this.ciclos.length) {
          this.idCiclo = this.ciclos[0].id_ciclo
        }
      }).catch((error) => {
        this.validarError(this.mensajeErrorHttp(error, 'Error al cargar ciclos'))
      }).finally(() => {
        this.cargar = false
      })
    },
    cargarMeta () {
      this.$http.get('kpi.apoyo.matriz.meta').then((response) => {
        const data = response.body || response.data || {}
        this.aplicarUsoGoogle(data)
      }).catch(() => {
        /* silencioso al abrir */
      })
    },
    aplicarUsoGoogle (data) {
      if (data && data.google_uso) {
        this.googleUso = data.google_uso
      }
      this.alertaCuota = !!(data && data.alerta_cuota)
    },
    queryParams () {
      const q = {
        id_ciclo: this.idCiclo,
        semana: this.semana,
      }
      if (this.ciudad) q.ciudad = this.ciudad
      return q
    },
    consultarMatriz () {
      if (!this.puedeConsultar) return
      this.consultando = true
      this.filtroTeacherId = null
      this.$http.get('kpi.apoyo.matriz', { params: this.queryParams() }).then((response) => {
        const data = response.body || response.data || {}
        this.aplicarUsoGoogle(data)
        if (!data.existe || !data.matriz) {
          this.matriz = null
          this.snapInfo = null
          this.validarError('No hay snapshot para ese ciclo/semana. Usa Generar / actualizar.')
          return
        }
        this.matriz = data.matriz
        this.snapInfo = data.matriz.snap || null
        this.asignarColores(data.matriz)
        this.validarSuccess('Matriz cargada')
      }).catch((error) => {
        this.validarError(this.mensajeErrorHttp(error, 'Error al consultar matriz'))
      }).finally(() => {
        this.consultando = false
      })
    },
    generarMatriz () {
      if (!this.puedeConsultar) return
      this.generando = true
      this.filtroTeacherId = null
      const payload = {
        id_ciclo: this.idCiclo,
        semana: this.semana,
        max_opciones: 15,
      }
      if (this.ciudad) payload.ciudad = this.ciudad
      this.$http.post('kpi.apoyo.matriz.generar', payload).then((response) => {
        const data = response.body || response.data || {}
        this.aplicarUsoGoogle(data)
        if (data.matriz) {
          this.matriz = data.matriz
          this.snapInfo = data.matriz.snap || null
          this.asignarColores(data.matriz)
        }
        this.validarSuccess(data.mensaje || 'Matriz generada')
      }).catch((error) => {
        this.validarError(this.mensajeErrorHttp(error, 'Error al generar matriz'))
      }).finally(() => {
        this.generando = false
      })
    },
    asignarColores (matriz) {
      const ids = []
      const vistos = {}
      const filas = (matriz && matriz.filas) || []
      for (let i = 0; i < filas.length; i++) {
        const celdas = filas[i].celdas || []
        for (let j = 0; j < celdas.length; j++) {
          const celda = celdas[j]
          if (!celda || celda.id_teacher == null) continue
          const key = String(celda.id_teacher)
          if (!vistos[key]) {
            vistos[key] = true
            ids.push(key)
          }
        }
      }
      ids.sort((a, b) => Number(a) - Number(b))
      const mapa = {}
      for (let i = 0; i < ids.length; i++) {
        mapa[ids[i]] = colorPorIndice(i)
      }
      this.colorPorTeacher = mapa
    },
    colorTeacher (idTeacher) {
      if (idTeacher == null) return '#EEEEEE'
      return this.colorPorTeacher[String(idTeacher)] || '#EEEEEE'
    },
    estiloCelda (celda) {
      if (!celda || celda.id_teacher == null) return {}
      return { backgroundColor: this.colorTeacher(celda.id_teacher) }
    },
    estiloTiempo (celda) {
      if (!celda || celda.id_teacher == null) return {}
      return {
        backgroundColor: this.colorTeacher(celda.id_teacher),
        opacity: 0.85,
      }
    },
    esCeldaAtenua (celda) {
      if (this.filtroTeacherId == null || this.filtroTeacherId === '') return false
      if (!celda) return true
      return Number(celda.id_teacher) !== Number(this.filtroTeacherId)
    },
    tituloCelda (celda) {
      if (!celda) return ''
      const tiempo =
        celda.tiempo_minutos != null ? (' · ' + celda.tiempo_minutos + ' min') : ''
      return this.nombreVisible(celda.nombre) + tiempo
    },
    etiquetaCiclo () {
      const found = (this.ciclos || []).find((c) => Number(c.id_ciclo) === Number(this.idCiclo))
      return found && found.ciclo ? String(found.ciclo) : ('C' + (this.idCiclo || ''))
    },
    exportarExcelMatriz () {
      if (!this.filasVisibles.length || !this.matriz) return
      const columnas = this.matriz.columnas || []
      const filas = this.filasVisibles
      const meta =
        this.etiquetaCiclo() +
        ' · Semana ' + this.semana +
        ' · Ciudad ' + (this.ciudad || 'TODAS')

      let html = ''
      html += '<html xmlns:o="urn:schemas-microsoft-com:office:office" '
      html += 'xmlns:x="urn:schemas-microsoft-com:office:excel" '
      html += 'xmlns="http://www.w3.org/TR/REC-html40">'
      html += '<head><meta charset="UTF-8">'
      html += '<!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets>'
      html += '<x:ExcelWorksheet><x:Name>Matriz</x:Name>'
      html += '<x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions>'
      html += '</x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]-->'
      html += '<style>'
      html += 'table{border-collapse:collapse;font-family:Calibri,Arial,sans-serif;font-size:11pt;}'
      html += 'th,td{border:1px solid #757575;padding:6px 8px;vertical-align:middle;}'
      html += 'th{background:#5D4037;color:#FFFFFF;font-weight:bold;text-align:center;}'
      html += '.plantel{background:#EFEBE9;font-weight:bold;text-align:left;}'
      html += '.tiempo{font-size:10pt;font-weight:bold;text-align:center;}'
      html += '.nombre{font-weight:bold;text-align:center;text-transform:uppercase;}'
      html += '.meta{font-size:10pt;color:#616161;margin-bottom:8px;}'
      html += '</style></head><body>'
      html += '<div class="meta">' + escapeHtml(meta) + '</div>'
      html += '<table>'
      html += '<tr><th style="width:140px">Plantel</th>'
      for (let o = 0; o < columnas.length; o++) {
        html += '<th style="width:160px">OPCION ' + columnas[o] + '</th>'
      }
      html += '</tr>'

      for (let i = 0; i < filas.length; i++) {
        const fila = filas[i]
        html += '<tr>'
        html +=
          '<td class="plantel" rowspan="2">' +
          escapeHtml(fila.nombre) +
          '</td>'
        for (let j = 0; j < columnas.length; j++) {
          const celda = (fila.celdas && fila.celdas[j]) || null
          if (!celda) {
            html += '<td></td>'
            continue
          }
          const bg = this.colorTeacher(celda.id_teacher)
          html +=
            '<td class="nombre" style="background-color:' +
            bg +
            '">' +
            escapeHtml(this.nombreVisible(celda.nombre)) +
            '</td>'
        }
        html += '</tr><tr>'
        for (let j = 0; j < columnas.length; j++) {
          const celda = (fila.celdas && fila.celdas[j]) || null
          if (!celda || celda.tiempo_minutos == null) {
            html += '<td class="tiempo"></td>'
            continue
          }
          const bg = this.colorTeacher(celda.id_teacher)
          html +=
            '<td class="tiempo" style="background-color:' +
            bg +
            '">' +
            escapeHtml(String(celda.tiempo_minutos) + ' minutos') +
            '</td>'
        }
        html += '</tr>'
      }

      html += '</table></body></html>'

      const blob = new Blob(['\ufeff' + html], {
        type: 'application/vnd.ms-excel;charset=utf-8',
      })
      const ciudadLabel = this.ciudad || 'TODAS'
      const nombreArchivo =
        'GRUPO_APOYO_' +
        this.etiquetaCiclo().replace(/\s+/g, '_') +
        '_S' + this.semana +
        '_' + ciudadLabel +
        '.xls'
      saveAs(blob, nombreArchivo)
      this.validarSuccess('Excel descargado con colores')
    },
  },
}
</script>

<style scoped>
.apoyo-matriz-wrap {
  overflow: auto;
  max-height: calc(100vh - 280px);
  border-top: 1px solid #e0e0e0;
}
.apoyo-matriz {
  border-collapse: separate;
  border-spacing: 0;
  table-layout: fixed;
  width: max-content;
  min-width: 100%;
  font-size: 11px;
}
.apoyo-matriz__col-plantel {
  width: 150px;
}
.apoyo-matriz__col-opcion {
  width: 148px;
}
.apoyo-matriz th,
.apoyo-matriz td {
  border: 1px solid #bdbdbd;
  padding: 6px;
  vertical-align: middle;
  box-sizing: border-box;
}
.apoyo-matriz thead th {
  position: sticky;
  top: 0;
  z-index: 2;
  background: #5d4037;
  color: #fff;
  font-weight: 700;
  text-align: center;
  padding: 10px 6px;
}
.apoyo-matriz__plantel {
  position: sticky;
  left: 0;
  z-index: 3;
  width: 150px;
  min-width: 150px;
  max-width: 150px;
}
.apoyo-matriz__plantel-nombre {
  position: sticky;
  left: 0;
  z-index: 1;
  width: 150px;
  min-width: 150px;
  max-width: 150px;
  background: #efebe9;
  font-weight: 700;
  text-transform: uppercase;
  word-break: break-word;
  white-space: normal;
  line-height: 1.25;
}
.apoyo-matriz__opcion {
  width: 148px;
  min-width: 148px;
  max-width: 148px;
}
.apoyo-matriz__celda {
  width: 148px;
  min-width: 148px;
  max-width: 148px;
  background: #fafafa;
  overflow: hidden;
  padding: 4px;
}
.apoyo-matriz__tiempo-celda {
  width: 148px;
  min-width: 148px;
  max-width: 148px;
  text-align: center;
  font-size: 10px;
  font-weight: 700;
  color: #212121;
  padding: 4px 6px !important;
}
.apoyo-matriz__celda--dim {
  opacity: 0.22;
}
.apoyo-matriz__chip {
  display: block;
  width: 100%;
  min-height: 44px;
  padding: 6px 5px;
  border-radius: 4px;
  box-sizing: border-box;
  overflow: hidden;
  color: #212121;
}
.apoyo-matriz__nombre {
  font-weight: 700;
  text-transform: uppercase;
  line-height: 1.2;
  word-break: break-word;
  overflow-wrap: anywhere;
  white-space: normal;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
  max-height: 3.6em;
  text-align: center;
}
.apoyo-matriz__tiempo-row td {
  border-top: none;
}
</style>
